import { AyvaRxOrderPayload } from "@/modules/medication/services/ayva-e-prescribe-service"
import { Commit } from "vuex"

function omitKey<T>(record: Record<string, T>, key: string): Record<string, T> {
  return Object.fromEntries(Object.entries(record).filter(([k]) => k !== key))
}

export interface State {
  stagedRxOrdersForCarePlanId: Record<string, AyvaRxOrderPayload[]>
}

const state = (): State => ({
  stagedRxOrdersForCarePlanId: {}
})

const getters = {
  getStagedRxOrdersForCarePlan: (state: State) => (carePlanId: string) => {
    const autoRefillItems = state.stagedRxOrdersForCarePlanId[carePlanId]
    return autoRefillItems ? autoRefillItems : []
  },

  getStagedRxOrderCountForCarePlan: (state: State) => (carePlanId: string) => {
    return state.stagedRxOrdersForCarePlanId[carePlanId]?.length || 0
  }
}

const actions = {
  stageOrUpdateRxOrder({ commit }: { commit: Commit }, payload: { carePlanId: string; item: AyvaRxOrderPayload }) {
    commit("stageOrUpdateRxOrder", payload)
  },

  unStageRxOrder({ commit }: { commit: Commit }, payload: { carePlanId: string; ordDrugCode: string }) {
    commit("unStageRxOrder", payload)
  },

  clearStagedRxOrders({ commit }: { commit: Commit }, payload: { carePlanId: string }) {
    commit("clearStagedRxOrders", payload.carePlanId)
  },
  clearStagedRxOrdersForAllCarePlans({ commit }: { commit: Commit }) {
    commit("clearStagedRxOrdersForAllCarePlans")
  }
}

const mutations = {
  stageOrUpdateRxOrder(state: State, payload: { carePlanId: string; item: AyvaRxOrderPayload }) {
    if (!state.stagedRxOrdersForCarePlanId[payload.carePlanId]) {
      state.stagedRxOrdersForCarePlanId = { ...state.stagedRxOrdersForCarePlanId, [payload.carePlanId]: [payload.item] }
      return
    }

    const existingIndex = state.stagedRxOrdersForCarePlanId[payload.carePlanId].findIndex(
      (order) => order.ordDrugCode === payload.item.ordDrugCode
    )

    if (existingIndex !== -1) {
      state.stagedRxOrdersForCarePlanId[payload.carePlanId].splice(existingIndex, 1, payload.item)
    } else {
      state.stagedRxOrdersForCarePlanId[payload.carePlanId].push(payload.item)
    }
  },

  unStageRxOrder(state: State, payload: { carePlanId: string; ordDrugCode: string }) {
    if (!state.stagedRxOrdersForCarePlanId[payload.carePlanId]) return

    const index = state.stagedRxOrdersForCarePlanId[payload.carePlanId].findIndex(
      (item) => item.ordDrugCode === payload.ordDrugCode
    )

    if (index === -1) return

    state.stagedRxOrdersForCarePlanId[payload.carePlanId].splice(index, 1)
    if (!state.stagedRxOrdersForCarePlanId[payload.carePlanId].length)
      state.stagedRxOrdersForCarePlanId = omitKey(state.stagedRxOrdersForCarePlanId, payload.carePlanId)
  },

  clearStagedRxOrders(state: State, carePlanId: string) {
    if (!state.stagedRxOrdersForCarePlanId[carePlanId]) return
    state.stagedRxOrdersForCarePlanId = omitKey(state.stagedRxOrdersForCarePlanId, carePlanId)
  },

  clearStagedRxOrdersForAllCarePlans(state: State) {
    state.stagedRxOrdersForCarePlanId = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
